import React, {Component} from 'react';
import { Link } from 'react-scroll';
import Logo from '../img/logo.svg';
class Header extends Component {
    
    
    render() {
       
            return (
<section className="bg-gradient bg-gardient-p pt-5 pb-6">
  <div className="container">
      <div className="row mt-6">
        <div className="col-md-8 mx-auto text-center">
            <img className="heading-img"src = {Logo} alt = "description" / >
            <h1>react-ig-feed</h1>
            <p className="lead mb-5">A React component to display a user's Instagram photos, Using Instagram Basic Display Graph API.</p>
            

            <Link className="btn btn-primary svg-icon mr-2" to='usage' smooth={true}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>                    Get Started

        </Link>


            <a target="_blank" rel="noreferrer" href="https://github.com/MohammedRaji/react-ig-feed" className="btn btn-dark svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>
                    Contribute
            </a>
        </div>
      </div>

    </div>
</section>

                

            );

        }

    }


export default Header;


